module.exports = __webpack_public_path__ + "static/media/formulare_round.8797b4b6.png";